import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './app-layout.component';
import { SharedModule } from '@sunedu/shared';
import { MenuGenRecursiveComponent } from './menugenrecursive.component';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  declarations: [AppLayoutComponent,MenuGenRecursiveComponent],
  exports: [AppLayoutComponent,MenuGenRecursiveComponent]
})
export class AppLayoutModule { }
